import template from './holidays.html';
import tr from '../../lib/default-translator.js';

class AdminHolidaysViewModel
{
	constructor(page)
	{
		this.page = page;
	}

	show_holidays_help()
	{
		Grape.dialog.open('HolidaysHelp', { employee_id: this.page.bindings.id });
	}
}

class AdminHolidaysPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminHolidaysViewModel(this);
	}

	init()
	{
		document.title = tr('Manage Holidays');
		window.current_page_title(tr('Add/Edit Holidays'));
	}
}

export default {
	route: '[/]admin/holidays',
	page_class: AdminHolidaysPage,
	template: template,
	template_filename: 'translation/holidays'
};
